import { Component, inject } from '@angular/core';
import { CookieService } from '@services/cookie/cookie.service';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  readonly #cookieService = inject(CookieService);
  readonly #authService = inject(AuthService);

  constructor() {
    this.#recoverySession();
  }

  #recoverySession() {
    const hasSession = this.#cookieService.checkSession();
    const hasSeller = this.#cookieService.checkSeller();
    if (hasSession && hasSeller) this.#authService.recoverySession();
  }
}
